import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useLayoutEffect, useState } from 'react';
import { ThemeProvider as EmotionThemeProvider } from '@emotion/react';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import merge from 'lodash/merge';
import { Box } from '../Box';
import defaultTheme from '../system/default-theme';
import { flattenPalette } from '../system';
import { objectToCSSProperties, shallowEqual } from '../utils';
import { getThemeDataAttribute, setRootStyles, styleReset } from './styles';
var STORAGE_KEY = 'tapestry-react-theme';
export var cache = createCache({
  key: 'tapestry-react'
});

function mergeIntoNewObject() {
  for (var _len = arguments.length, merges = new Array(_len), _key = 0; _key < _len; _key++) {
    merges[_key] = arguments[_key];
  }

  return merge.apply(void 0, [{}].concat(merges));
}

export var themeStorage = {
  get: function get() {
    return window.localStorage.getItem(STORAGE_KEY);
  },
  set: function set(value) {
    return window.localStorage.setItem(STORAGE_KEY, value);
  }
};
export var themeInitializerScript = "\ntry {\n  var theme = window.localStorage.getItem('" + STORAGE_KEY + "')\n  if (theme) {\n    document.documentElement.dataset.theme = theme\n  }\n} catch (e) {}\n";
var emptyTheme = {};

function mergeThemes(a, b) {
  var _a$button, _b$button, _a$spinner, _b$spinner, _a$spinner2, _b$spinner2;

  if (a === void 0) {
    a = {};
  }

  if (b === void 0) {
    b = {};
  }

  return _objectSpread(_objectSpread(_objectSpread({}, a), b), {}, {
    button: _objectSpread(_objectSpread(_objectSpread({}, a.button), b.button), {}, {
      themes: mergeIntoNewObject(((_a$button = a.button) == null ? void 0 : _a$button.themes) || {}, ((_b$button = b.button) == null ? void 0 : _b$button.themes) || {})
    }),
    colors: mergeIntoNewObject(flattenPalette(a.colors || {}), flattenPalette(b.colors || {})),
    spinner: _objectSpread(_objectSpread(_objectSpread({}, a.spinner), b.spinner), {}, {
      sizes: mergeIntoNewObject(((_a$spinner = a.spinner) == null ? void 0 : _a$spinner.sizes) || {}, ((_b$spinner = b.spinner) == null ? void 0 : _b$spinner.sizes) || {}),
      thickness: mergeIntoNewObject(((_a$spinner2 = a.spinner) == null ? void 0 : _a$spinner2.thickness) || {}, ((_b$spinner2 = b.spinner) == null ? void 0 : _b$spinner2.thickness) || {})
    })
  });
}

export function ThemeProvider(_ref) {
  var _ref2;

  var _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? emptyTheme : _ref$theme,
      children = _ref.children,
      boxProps = _objectWithoutPropertiesLoose(_ref, ["theme", "children"]);

  var _useState = useState(function () {
    return mergeThemes(defaultTheme, theme);
  }),
      mergedTheme = _useState[0],
      setMergedTheme = _useState[1];

  useLayoutEffect(function () {
    var nextTheme = mergeThemes(defaultTheme, theme);
    setRootStyles(nextTheme.id, objectToCSSProperties('colors', nextTheme.colors));

    if (!shallowEqual(mergedTheme, nextTheme)) {
      setMergedTheme(nextTheme);
    }
  }, [theme]);
  return /*#__PURE__*/React.createElement(CacheProvider, {
    value: cache
  }, /*#__PURE__*/React.createElement(EmotionThemeProvider, {
    theme: mergedTheme
  }, /*#__PURE__*/React.createElement(Box, _extends({
    className: "tapestry-react-reset"
  }, boxProps, (_ref2 = {}, _ref2["" + getThemeDataAttribute(mergedTheme.id)] = true, _ref2)), children)));
}
ThemeProvider.cache = cache;
ThemeProvider.setRootStyles = setRootStyles;
ThemeProvider.styleReset = styleReset;
ThemeProvider.themeInitializerScript = themeInitializerScript;
ThemeProvider.themeStorage = themeStorage;
export { setRootStyles, styleReset };